// extracted by mini-css-extract-plugin
export default {"ticketsContainer":"HGmfuBUIdUfQlHy9JTVB","withoutSubheader":"lBGg4_yp2slf0s2Jk4_N","withSubheader":"j1C83e0y6lIxM96cglgp","finishWorkButton":"zIadNhVOxxRemyMFg6_v"};